import Head from "next/head";
import EmailSignupBanner from "../components/EmailSignupBanner";
import Layout from "../components/Layout";
import { Modal, Pagination, Space, Text} from '@mantine/core'
import { MenuId } from "../components/Header";
import styles from './showcase.module.scss'


import { GetServerSideProps } from "next";
import { getSomeShowcaseItems } from "../lib/data";
import { RusAuthProps, RusContextProps, ShowcaseItem, UserImage } from "../lib/definitions";

import { createRef, useEffect, useLayoutEffect, useRef, useState } from "react";

import useAuth from "../lib/useAuth";

import { useWindowEvent } from '@mantine/hooks';
import { useRouter } from "next/router";


import { ImageUploadHandle } from "../components/ImageUpload";
import Masonry from "react-responsive-masonry";
import { AspectBox, AspectBox2 } from "../components/AspectBox";
import axios from "axios";
import { smartdevicemanagement } from "googleapis/build/src/apis/smartdevicemanagement";
import Link from "next/link";


const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;
  
type Data = {
  items : ShowcaseItem [],
  count : number

  }

const pageSize = 25;
export default function UserImages({data} : {data: Data & RusAuthProps & RusContextProps})
{
  let [lightboxImage, setLightboxImage] = useState<UserImage | null>(null);
  let [showLightboxFlag, setShowLightboxFlag] = useState(false);
  let [images, setImages] = useState(data.items);
  let pageCount=Math.ceil(data.count / pageSize);
  const {userInformation, authToken} = useAuth();
  let [pageNumber, setPageNumber]=useState(1);

  let uploadRef = createRef<ImageUploadHandle>();

  let canAdd = userInformation?.subscribed;

  let [imageWidth, setImageWidth] = useState(540);
  let [imageHeight, setImageHeight] = useState(540);
  let [loading, setLoading] = useState(false);

  const [justMe, pSetJustMe] = useState(false);

  const firstRender = useRef(true);
  
  const [offset,setOffset]=useState(0);

  function resizeImage()
  {
    if (lightboxImage)
    {
      let maxWidth = Math.max(window.innerWidth - 50,200);
      let maxHeight = Math.max(window.innerHeight - 100, 200);
      let width = maxWidth;
      let height = width * lightboxImage.height/lightboxImage.width;

      if (height>maxHeight)
      {
        height = maxHeight;
        width = height * lightboxImage.width / lightboxImage.height;
      }

      setImageWidth(width);
      setImageHeight(height);
      
    }
  }
  useIsomorphicLayoutEffect(()=>
  {
    resizeImage();
  }
  ,[lightboxImage]);

  useEffect(()=>
  {

  async function refreshList()
  {
    if (offset==0 && firstRender.current)
    {
      return;
    }
    firstRender.current=false;
    let x = await getSomeShowcaseItemsFromServer(offset, pageSize);
    setImages(x.items);
  }
  {
    refreshList();
  }}, [offset]);

  useWindowEvent("resize", ()=>{resizeImage()});

  function showLightbox(image: UserImage)
  {
    setLightboxImage(image);
    setShowLightboxFlag(true);
  }

  function closeLightbox()
  {
    setShowLightboxFlag(false);
  }

  function handlePageClick(page: number)
  {
    const newOffset = data == null ? 0 : (((page -1) * pageSize) % data.count);
    setOffset(newOffset);
    setPageNumber(page);
  }

  async function getSomeShowcaseItemsFromServer(offset: number, count: number)
  {

  let at = await axios.get(`/n/api/getshowcaseitems?offset=${offset}&count=${count}`);
  return  at.data;
  }

  
  let url = `https://user-images.rawumberstudios.com/${lightboxImage?.guid}_1080.jpg`;


    return(
        <>
        <Modal opened={showLightboxFlag} onClose={closeLightbox} fullScreen closeOnEscape={false}>


      <div style={{display:"flex", width:"100%", height:"100%", justifyContent:"center"}}>
      <div className={styles.lightboxBorder} style={{width:imageWidth, height:imageHeight}}>
        {lightboxImage && <div style={{ width:"100%", height:"100%", backgroundImage:`url('${url}')`, backgroundSize:"contain", backgroundPosition:"center", backgroundRepeat:"no-repeat"}}></div>}
        </div>
        </div>

        
        </Modal>
      
        <Layout menuId={MenuId.online}>

  
  <Head>
      <title>A showcase of our favourite work from our online sessions and workshops</title>
      <meta name="description" content="Our favourite work from our subscribers, and created in our in-person workshops"/>      
  </Head>
  <div className = {styles.mainContent}>
  <h1 className={styles.h1}>A showcase of our favourite work</h1>
    <Text ta="center">Here&rsquo;s some of our favourite work created from our <Link href="/upcoming-online-sessions">livestreams</Link>, <Link href="/new-video-search">video</Link> and <Link href="/image-search">image</Link> libraries, and <Link href="/new-events">workshops</Link>. Hover or click on each image to see who the artist is.</Text>
    <Text ta="center">Want us to consider your work? Submit it <Link href="/showcase-application-form">here</Link></Text>
  </div>
  
  <Space h='lg'/>
  
<div style={{maxWidth:1000, marginLeft:"auto", marginRight:"auto", position:"relative"}}>

<div className={styles.paginationContainer}>

<Pagination size="sm"
                onChange={handlePageClick}
                total={pageCount}
                value={pageNumber}
            />
</div>
<Masonry>
            {images.map(x => (
                <Tile key={x.id} image={x} />))}

        </Masonry>
        <div className={styles.paginationContainer}>
 <Pagination size="sm"
                onChange={handlePageClick}
                total={pageCount}
                value={pageNumber}
            />
</div>

</div>
  <EmailSignupBanner/>
  </Layout>



        </>

    );
  }

  function Tile({image} : {image:ShowcaseItem})
  {

    const [hover, setHover] = useState(false);

  async function mouseEnter(e: React.MouseEvent)
  {
    setHover(true);
  }

  async function mouseLeave(e: React.MouseEvent)
  {
    setHover(false);
  }

    let url = '';

    if (image.artistLink)
    {
      if (image.artistLink.startsWith("@"))
      {
        url = `https://instagram.com/${image.artistLink.substring(1)}`
      }
    }

    const imageUrl = `/n/api/thumbnails/${image?.imageData.id}?w=350&t=${image?.imageData.updatedAt}`;
    return <div onClick ={mouseEnter} onMouseEnter = {mouseEnter} onMouseLeave={mouseLeave} style={{margin:5}}>
      <AspectBox2 width= {image.imageData.width} height ={image.imageData.height}>
    <div style={{position:'relative'}}>
        {/*eslint-disable-next-line @next/next/no-img-element*/}
        <img style = {{borderRadius:5}} alt = {`Image`} src={imageUrl} width="100%"/>
       
    </div>
   
   {hover && <div style={{ textAlign:"center", position:'absolute', bottom:5, width:'100%', marginBottom:0, background:'#fffa'}}>{url?<a href={url} target='_blank'>{image.artist}</a>:image.artist}</div>}
 
    </AspectBox2>
    </div>
  }


export const getServerSideProps : GetServerSideProps = async (context)=>
{



    let x = await getSomeShowcaseItems(0, pageSize);


    return {
      props: {
        data: 
        { 
            items: x.items,
            count: x.totalCount
        }
     }   

    }
}
